import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const key = 'user'
const key2 = 'scope'
export default new Vuex.Store({
    state: {
        lang: 'zh',
        user: null,
        scope: null,
        maxWidth: null,
        isTip: null,
        hideModule: null,
        callBack:null,
    },
    getters: {
        getCallBack:function(state){
            if(!state.callBack){
                state.callBack = localStorage.getItem("callBack");
            }
            return state.callBack;
        },
        getMaxWidth:function(state){
            if(!state.maxWidth){
                state.maxWidth = localStorage.getItem("maxWidth");
            }
            return state.maxWidth
        },
        getHideModule:function(state){
            if(!state.hideModule){
                state.hideModule = localStorage.getItem("hideModule");
            }
            return state.hideModule
        },
        getIsTip:function(state){
            if(!state.isTip){
                state.isTip =  JSON.parse(localStorage.getItem("isTip"));
            }
            return state.isTip
        },
        getUser: function (state) {
            if (!state.user) {
                state.user = JSON.parse(localStorage.getItem(key))
            }
            return state.user
        },
        getScope:function (state) {
            if (!state.scope) {
                state.scope = JSON.parse(localStorage.getItem(key2))
            }
            return state.scope
        },
    },
    mutations: {
        setCallBack(state,value){
            state.callBack = value;
            localStorage.setItem('callBack',value);
        },
        removeCallBack(state){
            state.callBack = null;
            localStorage.removeItem('callBack');
        },
        setMaxWidth(state,value){
            state.maxWidth = value;
            localStorage.setItem('maxWidth',value);
        },
        removeMaxWidth(state){
            state.maxWidth = null;
            localStorage.removeItem('maxWidth');
        },
        setHideModule(state,value){
            state.hideModule = value;
            localStorage.setItem('hideModule',value);
        },
        removeHideModule(state){
            state.hideModule = null;
            localStorage.removeItem('hideModule');
        },
        setIsTip(state,value){
            state.isTip = value;
            localStorage.setItem('isTip',value);
        },
        removeIsTip(state){
            state.isTip = null;
            localStorage.removeItem('isTip');
        },
        setUserInfo (state, value) {
            state.user = value;
            localStorage.setItem(key, JSON.stringify(value))
        },
        removeUserInfo (state) {
            state.user = null;
            localStorage.removeItem(key)
        },
        setScope(state, value){
            state.scope = value;
            localStorage.setItem(key2, JSON.stringify(value))
        },
        removeScope(state){
            state.scope = null;
            localStorage.removeItem(key2)
        },
        changeLang(state, code) {
            if (code !== '') {
                this.state.lang = code
            }
        },
        changeMaxWidth(state,maxWidth){
            if(maxWidth !== ""){
                this.state.maxWidth = maxWidth;
            }
        },

    },
    actions: {},
    modules: {}
})
